import { initSubRoutes } from '../../../utils/router';

const RoutesDonneesPersonnelles = initSubRoutes({
    route: '/donnees-personnelles',
    subroutes: {},
    nom: 'Données personnelles',
});

export default RoutesDonneesPersonnelles;
